import type { TargetingBaseType } from 'sonata-static-storage/lib/schemas/targeting/TargetingBaseType';
import type { TagItem } from '@/components/common/FormExpandableSection/FormExpandableSection';

export function getLQITags(lqi?: TargetingBaseType['lqi']): TagItem[] {
  if (!lqi) {
    return [];
  }
  const result: TagItem[] = [];
  if (lqi?.prebid?.enabled) {
    result.push({ label: 'PRE BID' });
  }
  if (lqi?.postbid?.enabled) {
    result.push({ label: 'POST BID' });
  }

  return result;
}
